import Styled from 'styled-components'
import { maxQuery } from '../../../helpers'

export default Styled.div`
text-align: center;
color: #fff;
padding: 3.5em 0px;
position: relative;
img.floating--img {
    position: absolute;
    ${maxQuery('lg')} {
        display: none;
    }
    &.img--left__top {
        left: 0px;
    }
    &.img--left__bottom {
        left: 10%;
        top: 55%;
    }
    &.img--right__top {
        right: 0px;
    }
    &.img--right__bottom {
        right: 10%;
        top: 55%;
    }
}
h1 {
    font-weight: 700;
    font-size: 2.8rem;
    color: rgba(255, 255, 255, 0.95);
}
h2 {
    font-weight: 400;
    font-size: 1.1rem;
}
div.ellipse--container {
    position: relative;
    margin: 2em 0px;
    margin-bottom: 2.5em;
    ${maxQuery('>lg')} {
        width: 90%;
        margin: 2em auto;
    }
    img {
        ${maxQuery('1308px')} {
            display: none;
        }
        position: absolute;
        left: 21%;
        top: -1.3em;
    }
    h2 {
        line-height: 160%;
    }
}
div.img--container {
    text-align: center;
    img {
        display: inline-block;
        ${maxQuery('md')} {
            width: 100%;
            margin-left: 2em;
            height: 100%;
        }
    }
}

/* Action Buttons Container */
.action-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2.5em;
    margin-top: 2em;
    
    ${maxQuery('md')} {
        gap: 2em;
        padding: 0 1em;
    }
    
    button.primary-btn {
        display: inline-flex;
        font-size: 1rem;
        font-weight: 500;
        padding: 0.6em 4em;
        align-items: center;
        
        ${maxQuery('md')} {
            padding: 0.6em 2em;
            font-size: 0.9rem;
        }
        
        .icon {
            font-size: 1.8rem;
            margin-left: 0.2em;
        }
    }
}

/* Rider Apps Section */
.rider-apps {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
    
    .rider-text {
        font-size: 1.1rem;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.9);
        margin: 0;
    }
    
    .app-buttons {
        display: flex;
        gap: 1em;
        
        ${maxQuery('sm')} {
            gap: 0.8em;
            width: 100%;
            max-width: 400px;
        }
    }
    
    .app-btn {
        display: flex;
        align-items: center;
        gap: 0.7em;
        padding: 0.8em 1.8em;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;
        font-family: inherit;
        min-width: 140px;
        text-decoration: none;
        
        ${maxQuery('sm')} {
            flex: 1;
            padding: 0.75em 1em;
            gap: 0.5em;
            min-width: unset;
        }
        
        svg {
            font-size: 2.2rem;
            flex-shrink: 0;
            
            ${maxQuery('sm')} {
                font-size: 1.8rem;
            }
        }
        
        .btn-text {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
            line-height: 1.2;
            
            .small {
                font-size: 0.7rem;
                font-weight: 400;
                opacity: 0.9;
                
                ${maxQuery('sm')} {
                    font-size: 0.65rem;
                }
            }
            
            .large {
                font-size: 1.05rem;
                font-weight: 600;
                margin-top: 0.1em;
                
                ${maxQuery('sm')} {
                    font-size: 0.9rem;
                }
            }
        }
        
        &.ios-btn {
            background: #000;
            color: #fff;
            border: 1px solid rgba(255, 255, 255, 0.1);
            
            &:hover {
                background: #1a1a1a;
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
            }
            
            &:active {
                transform: translateY(0);
            }
        }
        
        &.android-btn {
            background: #fff;
            color: #000;
            border: 1px solid rgba(0, 0, 0, 0.1);
            
            &:hover {
                background: #f5f5f5;
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }
            
            &:active {
                transform: translateY(0);
            }
        }
    }
}

/* Track Order Section */
.track-order {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
    width: 100%;
    max-width: 600px;
    
    .track-text {
        font-size: 1.1rem;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.9);
        margin: 0;
    }
    
    .track-search {
        display: flex;
        width: 100%;
        gap: 0.5em;
        
        ${maxQuery('sm')} {
            flex-direction: column;
        }
        
        .track-input {
            flex: 1;
            padding: 0.8em 1.2em;
            border: 2px solid rgba(255, 255, 255, 0.2);
            border-radius: 8px;
            background: rgba(255, 255, 255, 0.1);
            color: #fff;
            font-size: 1rem;
            font-family: inherit;
            outline: none;
            transition: all 0.3s ease;
            
            &::placeholder {
                color: rgba(255, 255, 255, 0.5);
            }
            
            &:focus {
                border-color: ${({ theme }) => theme.primary};
                background: rgba(255, 255, 255, 0.15);
            }
            
            ${maxQuery('sm')} {
                width: 100%;
            }
        }
        
        .track-btn {
            display: flex;
            align-items: center;
            gap: 0.5em;
            padding: 0.8em 2em;
            border: none;
            border-radius: 8px;
            background: ${({ theme }) => theme.primary};
            color: #fff;
            font-size: 1rem;
            font-weight: 600;
            font-family: inherit;
            cursor: pointer;
            transition: all 0.3s ease;
            white-space: nowrap;
            
            svg {
                font-size: 1.2rem;
            }
            
            &:hover {
                opacity: 0.9;
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            }
            
            ${maxQuery('sm')} {
                width: 100%;
                justify-content: center;
            }
        }
    }
}

img.dottedBox--img {
    position: absolute;
    left: -10%;
    bottom: 0px;
    ${maxQuery('md')} {
        display: none;
    }
}
`
